<template>
  <div class="col-12 col-xl-12 col-md-12" style="height: 100%;">
    <div class="row" v-if="!files || files.length == 0">
      <div class="col-12 text-center pt-3">
        <i class="fa fa-info-circle"></i>
        {{ laborder ? $t("message.Report not uploaded yet") : $t("message.No Files available") }}
      </div>
      <div class="col-12 text-center">
        <lab-order-svg style="max-height: 80vh;"></lab-order-svg>
      </div>
    </div>
    <div class="row" v-if="showSearchBar">
      <div class="col-12" v-if="files && files.length > 0">
        <fg-input :placeholder="$t('message.Search')" v-model="search" addon-right-icon="fa fa-search" class="no-border"></fg-input>
      </div>
    </div>
    <div v-if="files.length > 0" class="row file-list-container">
      <!-- take full width in large devices -->
      <div class="col-12 col-lg-12">
        <!-- List for extra small devices -->
        <!-- display none for large devices not needed -->
        <div class="row d-block d-md-block" style="padding-bottom: 90px;">
          <div class="col-12 file-list" v-for="(file, index) in fileteredFiles" :key="file._id">
            <div>
              <div class="col-12">
                <div class="row">
                  <div class="col-2 col-md-2 col-lg-2" @click="viewFile(file)">
                    <div v-if="file.type.indexOf('image') > -1">
                      <dynamic-image :file-id="file.fileId" image-style="min-height: 20px; width: 100%">
                      </dynamic-image>
                    </div>
                    <div v-else-if="file.type.indexOf('pdf') > -1" style="text-align: center; font-size: xx-large;">
                      <i class="fa fa-file-pdf" style="font-size: 2em; color: #208fdc"></i>
                    </div>
                    <div v-else-if="file.type.indexOf('video') > -1" style="text-align: center; font-size: xx-large;">
                      <i class="fa fa-file-video" style="font-size: 2em; color: #208fdc"></i>
                    </div>
                    <div v-else-if="file.type.indexOf('audio') > -1" style="text-align: center; font-size: xx-large;">
                      <i class="fa fa-file-audio" style="font-size: 2em; color: #208fdc"></i>
                    </div>
                    <div v-else style="text-align: center; font-size: xx-large;">
                      <i class="fa fa-file" style="font-size: 2em; color: #208fdc"></i>
                    </div>
                  </div>
                  <div class="col-8 col-md-8 col-lg-8" @click="viewFile(file)">
                    <p class="card-heading reason" style="width: 100%;overflow: hidden;display: inline-block;text-overflow: ellipsis;white-space: nowrap;">{{ file.name }}</p>
                    <p class="card-heading file-date">
                      {{ getFormattedDate(file.created) }}
                    </p>
                  </div>
                  <div class="col-2 col-md-2 col-lg-2" style="color: red" @click="deleteFile(file, index)" v-if="deleteControl">
                    <i class="el-icon-delete"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showAddButton && uploadControl" class="pb-2 text-center" style="position: fixed;top: auto;z-index: 200;bottom: 4em;right: 50%;transform: translateX(50%);" :style="(!files || files.length < 1) ? { bottom: 'calc(100% - 50vh)' } : { bottom: '4em' }">
      <n-button style="margin-right:1em;" type="primary" round @click.native="selectFile">
        <i class="fa fa-upload"></i>
        {{ $t("message.Select") }}
      </n-button>
      <input type="file" ref="fileInput" style="display: none" @change="openFileChooser">
      <!-- <n-button type="primary" round @click.native="reportUpload">
        <i class="fa fa-camera"></i>
        {{ $t("message.Capture") }}
      </n-button> -->
      <n-button type="primary" round @click.native="openCameraModalForFileUpload">
        <i class="fa fa-camera"></i>
        {{ $t("message.Capture") }}
      </n-button>
      <div style="font-size: 0.8em;color: red;font-style: italic;">*{{ $t("message.Maximum file size allowed is 10MB!") }}</div>
    </div>

    <!-- Button -->
    <!-- <div style="
        position: absolute;
        display: grid;
        transition: visibility 0s, opacity 0.5s linear;
        z-index: 999;
        bottom: 60px;
        inset-inline-end: 0;
      " v-if="showButtons">
      <n-button style="margin-bottom: 0" type="primary" social icon round size="lg" @click.native="openFileChooser">
        <i class="fa fa-upload"></i>
      </n-button>
      <n-button type="primary" social icon round size="lg" @click.native="reportUpload">
        <i class="fa fa-camera"></i>
      </n-button>
    </div>
    <span v-if="showButtons" class="file-size-msg">*{{ $t("message.Maximum file size allowed is 10MB!") }}</span>
    <n-button v-if="showAddButton && uploadControl" type="info" social icon round size="lg" @click.native="showButtons = !showButtons" style="
        inset-inline-end: 0;
        bottom: 0;
        position: absolute;
        z-index: 999;
      ">
      <i v-if="!showButtons" class="fa fa-plus"></i>
      <i v-if="showButtons" class="fa fa-minus"></i>
    </n-button> -->

    <!-- View file modal-->
    <modal :show.sync="fileToView" headerClasses="d-none" class="view-file-modal" footerClasses="d-none" modalContentClasses="write-post-modal-content" :showClose="false" :animationDuration="250">

      <div class="view-file-header " v-show="showOptions">
        <i class="now-ui-icons ui-1_simple-remove close-icon" @click="closeModal"></i>
        <i class="now-ui-icons arrows-1_cloud-download-93" style="font-weight: 900;font-size: 1.2em;color: #a5a5a5;" @click="downloadFile(fileToView)"></i>
      </div>

      <div v-if="fileToView" class="file-wrapper" @click="showOptions = !showOptions">
        <dynamic-image v-if="fileToView.type.indexOf('image') > -1" :file-id="fileToView.fileId" image-id="signature-img" image-style="max-height: 100%;"></dynamic-image>

        <iframe v-if="fileToView.type.indexOf('application/pdf') > -1" :src="baseUrl + '/file/' + fileToView.fileId" style="height: 80%; width: 80%;"></iframe>

        <dynamic-video v-if="fileToView.type.includes('video/')" :file-id="fileToView.fileId" controlsList="nodownload" :options="{ controls: true }" />
      </div>

    </modal>

    <app-camera :showCam="SHOW_CAPTURE_MODAL" ref="camera" @closeCamera="closeCaptureModal" @imageCaptured="saveImage">
    </app-camera>
  </div>
</template>
<script>
import LabOrderSvg from "../components/svg_images/LabOrderSvg.vue";
import AppCamera from "./AppCamera.vue";

var moment = require("moment");
export default {
  components: {
    LabOrderSvg,
    AppCamera
  },
  props: {
    showSearchBar: {
      type: Boolean,
      default: true,
    },
    files: Array,
    patientId: String,
    showAddButton: {
      type: Boolean,
      default: false,
    },
    laborder: Object,
    deleteControl: {
      type: Boolean,
      default: true,
    },
    uploadControl: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      SHOW_CAPTURE_MODAL: false,
      showButtons: false,
      search: "",
      cameraOptions: {},
      //File viewer
      fileToView: null,
      showOptions: true,
    };
  },
  computed: {
    fileteredFiles() {
      return this.files.filter((file) => {
        return (
          !this.search ||
          file.name.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
    viewLink() {
      return this.baseUrl + "/viewFile/";
    },
    previewLink() {
      return this.baseUrl + "/file/";
    },
  },
  mounted() {
    let _this = this;
    if (typeof Camera !== "undefined") {
      this.cameraOptions = {
        sourceType: Camera.PictureSourceType.CAMERA,
        destinationType: Camera.DestinationType.DATA_URL,
        mediaType: Camera.MediaType.PICTURE,
        // allowEdit: true,
        correctOrientation: false,
        encodingType: Camera.EncodingType.PNG,
        quality: 10,
        cameraDirection: Camera.Direction.BACK,
        targetWidth: 300,
        targetHeight: 400,
      };
    }
  },
  methods: {
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm a");
    },
    // eslint-disable-next-line
    // async viewFile(file) {
    //   let that = this;
    //   try {
    //     let loader = this.$loading.show({
    //       // Optional parameters
    //       container: null,
    //       canCancel: false,
    //     });
    //     //get file from server
    //     let fileArrayBuffer = await this.$store.dispatch(
    //       "getFile",
    //       file.fileId
    //     );

    //     let pdfBlob = new Blob([fileArrayBuffer]);

    //     let storageLocation = "";

    //     if (typeof device !== "undefined") {
    //       switch (device.platform) {
    //         case "Android":
    //           storageLocation = cordova.file.externalDataDirectory;
    //           break;

    //         case "iOS":
    //           storageLocation = cordova.file.documentsDirectory;
    //           break;
    //       }

    //       let folderPath = storageLocation;

    //       window.resolveLocalFileSystemURL(
    //         folderPath,
    //         function (dir) {
    //           dir.getFile(
    //             file.name,
    //             {
    //               create: true,
    //             },
    //             function (file) {
    //               file.createWriter(
    //                 function (fileWriter) {
    //                   fileWriter.write(pdfBlob);

    //                   fileWriter.onwriteend = function () {
    //                     var url = file.nativeURL;
    //                     cordova.plugins.fileOpener2.open(url, pdfBlob.type, {
    //                       error: function error(err) {
    //                         console.error(err);
    //                         loader.hide();
    //                         alert(that.$t("message.filecard3"));
    //                       },
    //                       success: function success() {
    //                         loader.hide();
    //                         console.log("success with opening the file");
    //                       },
    //                     });
    //                   };

    //                   fileWriter.onerror = function (err) {
    //                     loader.hide();
    //                     alert(this.$t("message.filecard3"));
    //                     console.error(err);
    //                   };
    //                 },
    //                 function (err) {
    //                   loader.hide();
    //                   // failed
    //                   alert(this.$t("message.filecard3"));
    //                   console.error(err);
    //                 }
    //               );
    //             },
    //             function (err) {
    //               loader.hide();
    //               alert(this.$t("message.filecard3"));
    //               console.error(err);
    //             }
    //           );
    //         },
    //         function (err) {
    //           loader.hide();
    //           alert(this.$t("message.filecard3"));
    //           console.error(err);
    //         }
    //       );
    //     }
    //   } catch (e) {
    //     loader.hide();
    //     console.log(e);
    //   }
    // },
    viewFile(file) {
      this.fileToView = file;
      this.showOptions = true;
    },
    closeModal() {
      this.fileToView = null;
    },
    async saveFile(file) {
      //if file size is> 10MB, reject
      //1000000
      let _this = this;
      if (file.size / 1000000 > 10) {
        swal.fire({
          title: _this.$t("message.Ooops!"),
          text: _this.$t("message.Maximum file size allowed is 10MB!"),
          type: "error",
          timer: 5000,
        });
      } else {
        file.patientId = _this.patientId;
        if (_this.laborder) {
          file.laborderId = _this.laborder._id;
          file.kind = "PatientLabReport";
        }
        let loader = this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
        });
        try {
          let _file = await _this.$store.dispatch("uploadFile", file);
          this.files.unshift(_file);
          loader.hide();
          swal.fire({
            title: _this.$t("message.Success!"),
            text: _this.laborder
              ? _this.$t("message.Report uploaded Successfully")
              : _this.$t("message.File saved Successfully"),
            type: "success",
            timer: 3000,
          });
        } catch (err) {
          loader.hide();
          swal.fire({
            title: _this.$t("message.Ooops!"),
            text: _this.$t("message.Error while uploading file!"),
            type: "error",
            timer: 5000,
          });
        }
      }
    },

    async selectFile() {
      var isCordovaApp = !!window.cordova
      if (isCordovaApp) {
        let _this = this;
        let loader = _this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
        });
        let file = await chooser.getFile()
        if (file) {
          loader.hide();
          const { value: fileName } = await swal.fire({
            title: _this.$t("message.filecard10"),
            input: "text",
            inputValue: file.name,
            showCancelButton: true,
            inputValidator: (value) => {
              return !value && _this.$t("message.filecard18");
            },
          });
          if (fileName) {
            let fileBlob = new Blob([file.data]);
            let fileToSave = {
              name: fileName,
              data: fileBlob,
              type: file.mediaType,
              size: fileBlob.size,
            };
            this.saveFile(fileToSave);
          }
        }
        loader.hide();
      }
      else {
        this.$refs.fileInput.click();
      }
    },

    async openFileChooser(event) {
      let _this = this;
      let loader = _this.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
      });
      let file = event.target.files[0]
      if (file) {
        loader.hide();
        const { value: fileName } = await swal.fire({
          title: _this.$t("message.Enter file name"),
          input: "text",
          inputValue: file.name,
          showCancelButton: true,
          inputValidator: (value) => {
            return !value && _this.$t("message.Please Enter filename!");
          },
        });
        if (fileName) {
          let fileBlob = new Blob([file]);
          let fileToSave = {
            name: fileName,
            data: fileBlob,
            type: file.type,
            size: fileBlob.size,
          };
          this.saveFile(fileToSave);
        }
      }
      loader.hide();
    },
    async deleteFile(file, index) {
      let _this = this;
      swal
        .fire({
          title: _this.$t("message.Delete File?"),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: _this.$t("message.Yes"),
          cancelButtonText: _this.$t("message.No"),
          closeOnConfirm: true,
        })
        .then(async (confirm) => {
          if (confirm.value) {
            let loader = _this.$loading.show({
              // Optional parameters
              container: null,
              canCancel: false,
            });
            try {
              let _file = await _this.$store.dispatch("deleteFile", file);
              this.files.splice(index, 1);
              loader.hide();
              swal.fire({
                title: _this.$t("message.Success!"),
                text: _this.laborder
                  ? _this.$t("message.Report deleted successfully")
                  : _this.$t("message.File deleted successfully"),
                type: "success",
                timer: 3000,
              });
            } catch (err) {
              loader.hide();
              swal.fire({
                title: _this.$t("message.Ooops!"),
                text: _this.$t("message.Error while deleting file"),
                type: "error",
                timer: 5000,
              });
            }
          } else {
            swal.close();
          }
        });
    },

    async reportUpload() {
      var _this = this;
      let patient = _this.patient;
      navigator.camera.getPicture(
        async function (base64Data) {
          var fileData = "data:image/png;base64," + base64Data;
          const { value: fileName } = await swal.fire({
            title: _this.$t("message.Enter file name"),
            input: "text",
            inputValue: "Untitled.png",
            showCancelButton: true,
            inputValidator: (value) => {
              return !value && _this.$t("message.Please Enter filename!");
            },
          });
          if (fileName) {
            let fileBlob = _this.dataURItoBlob(fileData);
            let fileToSave = {
              name: fileName.endsWith(".png") ? fileName : fileName + ".png",
              data: fileBlob,
              type: "image/png",
              size: fileBlob.size,
            };
            _this.saveFile(fileToSave);
          }
        },
        function (err) {
          console.log("error opening camera");
        },
        _this.cameraOptions
      );
    },
    dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      var byteString = atob(dataURI.split(",")[1]);

      // separate out the mime component
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length);

      // create a view into the buffer
      var ia = new Uint8Array(ab);

      // set the bytes of the buffer to the correct values
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      // write the ArrayBuffer to a blob, and you're done
      var blob = new Blob([ab], { type: mimeString });
      return blob;
    },
    downloadFile(fileToView) {
      window.open(this.$store.state.baseUrl + "/download/" + fileToView.fileId)
    },
    openCameraModalForFileUpload() {
      var isCordovaApp = !!window.cordova
      if (isCordovaApp) {
        this.reportUpload()
      }
      else {
        setTimeout(() => {
          this.SHOW_CAPTURE_MODAL = true;
          this.$refs.camera.createCameraElement();
        }, 1000);
      }
    },
    closeCaptureModal() {
      this.SHOW_CAPTURE_MODAL = false;
    },
    async saveImage(fileData) {
      let _this = this;

      const { value: fileName } = await swal.fire({
        title: _this.$t("message.filecard10"),
        input: "text",
        inputValue: "Untitled.png",
        showCancelButton: true,
        inputValidator: (value) => {
          return !value && "Please Enter filename!";
        },
      });

      if (fileName) {
        let fileBlob = _this.dataURItoBlob(fileData);
        let fileToSave = {
          name: fileName.endsWith(".png") ? fileName : fileName + ".png",
          data: fileBlob,
          type: "image/png",
          size: fileBlob.size,
        };
        _this.saveFile(fileToSave);
      }
    },
  },
};
</script>
<style>
.file-list-container {
  height: calc(100% - 50px);
  overflow: scroll;
}

.file-list {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}

.file-list:first-child {
  border-top: none;
}

.file-list.selected {
  background-color: whitesmoke;
}

.file-icon {
  line-height: 3em;
  color: #2ca8ff;
  font-size: 1.5em;
}

.reason {
  font-size: 0.8em;
  margin-bottom: 2px;
}

.file-date {
  font-size: 0.6em;
  font-style: italic;
  color: grey;
  margin-bottom: 2px;
}

.file-size-msg {
  position: absolute;
  bottom: 0;
  font-size: 0.8em;
  color: red;
  font-style: italic;
}

.not-found-img {
  width: 100%;
}

/deep/ .has-success .form-control:focus + .input-group-addon {
  color: #555555;
}

/deep/ .el-input__inner {
  border-radius: 2em;
}
</style>

<style scoped>
/deep/ .view-file-modal .modal-content .modal-body {
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
  height: 100%;
  padding-bottom: 0px;
}

/deep/ .view-file-modal .modal-dialog {
  margin: 0;
}

/deep/ .view-file-modal .modal-content {
  background-color: black;
  height: 100vh
}

/deep/ .view-file-modal .file-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/ .view-file-modal .close-icon {
  font-weight: 900;
  font-size: 1.2em;
  color: #a5a5a5;
  padding: 1rem;
}

/deep/ .view-file-modal .view-file-header {
  position: absolute;
  z-index: 1;
  background: #343a4080;
  width: 100%;
}
</style>
